<template>
  <!-- <v-card class="mx-auto" max-width="400" min-width="300" min-height="310" outlined :loading="loading"> -->
  <v-card class="mx-auto" max-width="400" min-width="400" min-height="683" outlined :loading="loading">
    <template slot="progress">
      <v-progress-linear color="deep-purple" height="3" indeterminate></v-progress-linear>
    </template>
    <v-list-item three-line >
      <v-list-item-content>
        <div class="text-overline text-center">{{labelCategoria}}</div>
        <v-list-item-subtitle style="min-height: 32px;">
          <v-row no-gutters>
            <v-col><v-switch v-if="labelSwitchPeriodo" v-model="ultimoPeriodo" :label="labelSwitchPeriodo" class="ml-3" dense @change="onAggiorna"></v-switch></v-col>
            <v-col><v-select v-if="sceltaPeriodo" :items="tipiPeriodo" v-model="periodo" label="Periodo" class="pt-3" dense @change="onAggiorna"></v-select></v-col>
          </v-row>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="text-overline">
          FATTURE ATTIVE      
        </v-list-item-title>
        <v-divider class="mb-3"></v-divider>
        <v-list-item-subtitle>
          <v-row dense> 
            <v-col>Numero</v-col><v-col>{{ attiveNumero }}</v-col>
          </v-row>
          <v-row dense> 
            <v-col>Scadenze non saldate</v-col><v-col>{{ attiveScadenze }}</v-col>
          </v-row>
          <!-- TODO: Rivedere calcolo numero fatture in errore e rimettere -->
          <!-- <v-row dense> 
            <v-col>Errori presenti</v-col><v-col>{{ attiveErrori }}</v-col>
          </v-row> -->
          <v-row dense> 
            <v-col>Non trasferite</v-col><v-col>{{ attiveNonTrasferite }}</v-col>
          </v-row>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item class="mt-5 mb-5">
      <v-list-item-content>   
        <v-list-item-title class="text-overline">
          FATTURE PASSIVE      
        </v-list-item-title>
        <v-divider class="mb-3"></v-divider>
        <v-list-item-subtitle>
          <v-row dense> 
            <v-col>Numero</v-col><v-col>{{ passiveNumero}}</v-col>
          </v-row>
          <v-row dense>
            <v-col>Scadenze non saldate</v-col><v-col>{{ passiveScadenze }}</v-col>
          </v-row>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item class="mt-5 mb-5">
      <v-list-item-content>   
        <v-list-item-title class="text-overline">
          FATTURE ACQUISTATE      
        </v-list-item-title>
        <v-divider class="mb-3"></v-divider>
        <v-list-item-subtitle>
          <v-row dense> 
            <v-col>Numero</v-col><v-col>{{ acquistateNumero }}</v-col>
          </v-row>
          <v-row dense>
            <v-col>Usate</v-col><v-col>{{ acquistateUsate }}</v-col>
          </v-row>
          <v-row dense>
            <v-col>Residue</v-col><v-col>{{ acquistateResidue }}</v-col>
          </v-row>
          <v-row dense>
            <v-col>Scadenza</v-col><v-col>{{ acquistateDataScadenza | date }}</v-col>
          </v-row>          
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>    
    <!-- <div class="listaFatture"></div> -->
    <v-card-actions class="d-flex justify-space-around">
      <v-badge bordered color="error" icon="mdi-timer-outline" overlap :value="timerOn">
        <v-btn outlined text @click="onAggiorna">Aggiorna<v-icon right>mdi-refresh</v-icon></v-btn>
      </v-badge>
    </v-card-actions>
    <v-card-text class="pt-0">  
      <v-divider class="my-5"></v-divider>
      <v-icon class="mr-2" small :color="lastElement ? '' : 'white'">mdi-clock-outline</v-icon>
      <span class="text-caption grey--text font-weight-light">{{ ultimoAcquisto }}</span>
    </v-card-text>     
  </v-card>
</template>

<script>
import moment from 'moment'
import documenti from '@/services/documentiService'

export default {
  components: {
  },
  props: {
    id: String,
    categoria: String,
    tipo: String,
    label: String,
    switchLabel: String,
    avviaTimer: { type: Boolean, default: false },
    sceltaPeriodo: { type: Boolean, default: false },
    lastElement: { type: Boolean, default: false },
    routerLeave: Number
  },
  data(vm) {
    return {
      loading: false,
      dati: [],
      sum: {},
      ultimoPeriodo: false,
      labels: [],
      quantita: [],
      valore: [],
      espanso: false,
      timerOn: vm.avviaTimer,
      intervalAggiornamento: null,
      ultimoMovimento: null,
      raggruppamento: vm.label,
      tipiPeriodo: ['anno in corso', 'anno precedente'],
      tipiPeriodoCalcolo: ['year', 'lastyear'],
      periodo: 'anno in corso',      
      switchLabelPeriodo: ['', ''],
      intervalloAggiornamentoMinuti: 5,
      riepilogo: null
    }
  },
  watch: {
    periodo(value) {
      if (['mese', 'anno in corso'].includes(this.periodo)) {
        if (!this.intervalAggiornamento) {
          this.intervalAggiornamento = setInterval(async () => {
            await this.onAggiorna()
          }, this.intervalloAggiornamentoMinuti * 60 * 1000)
          this.timerOn = true
        }
      } else {
        if (this.intervalAggiornamento) {
          clearInterval(this.intervalAggiornamento)
          this.intervalAggiornamento = null
          this.timerOn = false
        }
      }
    },
    routerLeaveTrigger() {
      console.log('router leave snip')
      if (this.intervalAggiornamento) {
        clearInterval(this.intervalAggiornamento)
        this.intervalAggiornamento = null
      }
    }
  },
  mounted() {
    setTimeout(async () => {
      await this.onAggiorna()    
    }, Math.random() * 1000);

    if (this.avviaTimer || (this.sceltaPeriodo && ['mese', 'anno in corso'].includes(this.periodo))) {
      this.timerOn = true
      this.intervalAggiornamento = setInterval(async () => {
        await this.onAggiorna()
      }, this.intervalloAggiornamentoMinuti * 60 * 1000);  
    }
  },
  beforeDestroy() {
    if (this.intervalAggiornamento) {
      clearInterval(this.intervalAggiornamento)
      this.intervalAggiornamento = null
    }
  },
  computed:{
    ultimoAcquisto() {
      return this.ultimoMovimento ? 'ultimo acquisto ' + moment(this.ultimoMovimento).fromNow() : ''
    },    
    labelCategoria() {
      return this.categoria
    },
    labelSwitchPeriodo() {
/*       if (this.sceltaPeriodo) {
        const idx = this.tipiPeriodo.indexOf(this.periodo)
        return this.switchLabelPeriodo[idx]
      } else { */
      return ['mese', 'anno precedente'].includes(this.periodo) ? '' : this.switchLabel
/*       } */
    },
    routerLeaveTrigger() {
      return this.routerLeave
    },
    passiveNumero() {
      return this.riepilogo && !this.loading ? this.ultimoPeriodo && this.periodo === 'anno in corso' ? this.riepilogo.passive.numero12 : this.riepilogo.passive.numero : '---'
    },
    passiveScadenze() {
      return this.riepilogo && !this.loading ? this.ultimoPeriodo && this.periodo === 'anno in corso' ? this.riepilogo.passive.scadenze12 : this.riepilogo.passive.scadenze : '---'
    },
    attiveNumero() {
      return this.riepilogo && !this.loading ? this.ultimoPeriodo && this.periodo === 'anno in corso' ? this.riepilogo.attive.numero12 : this.riepilogo.attive.numero : '---'
    },
    attiveScadenze() {
      return this.riepilogo && !this.loading ? this.ultimoPeriodo && this.periodo === 'anno in corso' ? this.riepilogo.attive.scadenze12 : this.riepilogo.attive.scadenze : '---'
    },
    attiveErrori() {
      return this.riepilogo && !this.loading ? this.ultimoPeriodo && this.periodo === 'anno in corso' ? this.riepilogo.attive.errori12 : this.riepilogo.attive.errori : '---'
    },
    attiveNonTrasferite() {
      return this.riepilogo && !this.loading ? this.ultimoPeriodo && this.periodo === 'anno in corso' ? this.riepilogo.attive.nonTrasferito12 : this.riepilogo.attive.nonTrasferito : '---'
    },
    acquistateNumero() {
      return 0
    },
    acquistateUsate() {
      return 0
    },
	  acquistateResidue() {
      return 0
    },
	  acquistateDataScadenza() {
      return 0
    }
  },
  methods: {
    inizio(tipo) {
      let offset = 0
      let tipoCalcolo = tipo
      if (tipo === 'lastyear') {
        offset = 1
        tipoCalcolo = 'year'
      }
      const valore = moment().add(-offset, 'year').startOf(tipoCalcolo).format('YYYYMMDDHHmmss')
      return valore
    },
    fine(tipo) {
      let offset = 0
      let tipoCalcolo = tipo
      if (tipo === 'lastyear') {
        offset = 1
        tipoCalcolo = 'year'
      }
      const valore = moment().add(-offset, 'year').endOf(tipoCalcolo).format('YYYYMMDDHHmmss')
      return valore
    },
    async onAggiorna() {
      this.loading = true
      const idx = this.tipiPeriodo.indexOf(this.periodo)
      const periodoCalcolo = this.tipiPeriodoCalcolo[idx]
      const tipo = this.sceltaPeriodo ? periodoCalcolo : this.tipo
      const filtro = {
        start: this.inizio(tipo),
        end: this.fine(tipo)
      }
      const payload = {
        tipo
      }
      this.riepilogo = await documenti.statisticaRiepilogoFatture(filtro, payload)

      if (this.riepilogo instanceof Error || !this.riepilogo || this.riepilogo.status === "error") {
        await this.$nextTick()
        setTimeout(async () => {
          await this.onAggiorna()    
        }, 1000)
        return 
      }
      this.loading = false
    }
  }
}
</script>

<style lang="css" scoped>
  .listaFatture {
    min-height: 150px;
  }
</style>
